import { Link } from 'react-router-dom';

type LinkProps = { component: typeof Link; to: string };

type ExternalLinkProps = {
  component: 'a';
  href: string;
  target: '_blank';
  rel: 'noreferrer';
};

export const toLinkProps = (to?: string): LinkProps | undefined =>
  to ? { component: Link, to } : undefined;

export const toExternalLinkProps = (href?: string): ExternalLinkProps | undefined =>
  href ? { component: 'a', href, target: '_blank', rel: 'noreferrer' } : undefined;
